import actionableCounts from './actionableCounts'
import apiSecrets from './apiSecrets'
import auth from './auth'
import changeLog from './changeLog'
import sheetSyncRuns from './sheetSyncRuns'
import sheetSyncFindings from './sheetSyncFindings'
import contacts from './contacts'
import countries from './countries'
import expenseSubmissionBatches from './expenseSubmissionBatches'
import expenseSubmissionComments from './expenseSubmissionComments'
import expenseSubmissions from './expenseSubmissions'
import costCenterTransfers from './costCenterTransfers'
import explainer from './explainer'
import grepTester from './grepTester'
import invoiceRequestComments from './invoiceRequestComments'
import invoiceRequestItems from './invoiceRequestItems'
import invoiceRequestShippingEmails from './invoiceRequestShippingEmails'
import invoiceRequests from './invoiceRequests'
import kmMapComments from './kmMapComments'
import kmMapTrips from './kmMapTrips'
import kmMaps from './kmMaps'
import onboarding from './onboarding'
import onboardingFields from './onboardingFields'
import mbway from './mbway'
import memberApplicationPhotos from './memberApplicationPhotos'
import memberApplicationStates from './memberApplicationStates'
import memberApplications from './memberApplications'
import memberPhotos from './memberPhotos'
import memberStateNames from './memberStateNames'
import memberStates from './memberStates'
import members from './members'
import membershipCardLetters from './membershipCardLetters'
import membershipCards from './membershipCards'
import menuItem from './menuItem'
import messageSettings from './messageSettings'
import messages from './messages'
import notificationPreferences from './notificationPreferences'
import notificationUserSettings from './notificationUserSettings'
import oidcClients from './oidcClients'
import outboundEmails from './outboundEmails'
import paymentAdvice from './paymentAdvice'
import paymentMessage from './paymentMessage'
import payments from './payments'
import pdfDocuments from './pdfDocuments'
import people from './people'
import peopleACL from './peopleACL'
import peopleResearcher from './peopleResearcher'
import personPhotos from './personPhotos'
import reports from './reports'
import settings from './settings'
import toolbar from './toolbar'
import transactionCategories from './transactionCategories'
import pronobisImportStatus from './pronobisImportStatus'
import pronobisTransactions from './pronobisTransactions'
import transactions from './transactions.js'
import treasuryDocs from './treasuryDocs'
import unsettledPayments from './unsettledPayments'
import users from './users'
import { createStore as createVuexStore } from 'vuex'

export const createStore = (app) => {
  return createVuexStore({
    state: {
      responseTime: 0,
      debug: false,
      appReady: false,
      serverStatus: 'ok',
      offline: false,
      versionMismatch: false,
    },
    mutations: {
      setResponseTime(state, responseTime) {
        Object.assign(state, { responseTime })
      },
      toggleDebug(state) {
        state.debug = !state.debug
      },
      appReady(state, v) {
        state.appReady = v
      },
      serverStatus(state, v) {
        state.serverStatus = v
      },
      setOffline(state, v) {
        state.offline = v
      },
      setVersionMismatch(state, v) {
        state.versionMismatch = v
      },
    },
    actions: {
      setResponseTime(context, v) {
        context.commit('setResponseTime', v)
      },
      toggleDebug(context) {
        context.commit('toggleDebug')
      },
      appReady(context, v) {
        context.commit('appReady', v)
      },
      serverStatus(context, v) {
        context.commit('serverStatus', v)
      },
      setOffline(context, v) {
        context.commit('setOffline', v)
      },
      setVersionMismatch(context, v) {
        context.commit('setVersionMismatch', v)
      },
    },
    modules: {
      actionableCounts: actionableCounts(app),
      apiSecrets: apiSecrets(app),
      auth: auth(app),
      changeLog: changeLog(app),
      sheetSyncRuns: sheetSyncRuns(app),
      sheetSyncFindings: sheetSyncFindings(app),
      contacts: contacts(app),
      countries: countries(app),
      expenseSubmissionBatches: expenseSubmissionBatches(app),
      expenseSubmissionComments: expenseSubmissionComments(app),
      expenseSubmissions: expenseSubmissions(app),
      costCenterTransfers: costCenterTransfers(app),
      explainer: explainer(app),
      grepTester: grepTester(app),
      invoiceRequestComments: invoiceRequestComments(app),
      invoiceRequestItems: invoiceRequestItems(app),
      invoiceRequestShippingEmails: invoiceRequestShippingEmails(app),
      invoiceRequests: invoiceRequests(app),
      kmMapComments: kmMapComments(app),
      kmMapTrips: kmMapTrips(app),
      kmMaps: kmMaps(app),
      onboarding: onboarding(app),
      onboardingFields: onboardingFields(app),
      mbway: mbway(app),
      memberApplicationPhotos: memberApplicationPhotos(app),
      memberApplicationStates: memberApplicationStates(app),
      memberApplications: memberApplications(app),
      memberPhotos: memberPhotos(app),
      memberStateNames: memberStateNames(app),
      memberStates: memberStates(app),
      members: members(app),
      membershipCardLetters: membershipCardLetters(app),
      membershipCards: membershipCards(app),
      menuItem: menuItem(app),
      messageSettings: messageSettings(app),
      messages: messages(app),
      notificationPreferences: notificationPreferences(app),
      notificationUserSettings: notificationUserSettings(app),
      oidcClients: oidcClients(app),
      outboundEmails: outboundEmails(app),
      paymentAdvice: paymentAdvice(app),
      paymentMessage: paymentMessage(app),
      payments: payments(app),
      pdfDocuments: pdfDocuments(app),
      people: people(app),
      peopleACL: peopleACL(app),
      peopleResearcher: peopleResearcher(app),
      personPhotos: personPhotos(app),
      reports: reports(app),
      settings: settings(app),
      toolbar: toolbar(app),
      pronobisImportStatus: pronobisImportStatus(app),
      pronobisTransactions: pronobisTransactions(app),
      transactionCategories: transactionCategories(app),
      transactions: transactions(app),
      treasuryDocs: treasuryDocs(app),
      unsettledPayments: unsettledPayments(app),
      users: users(app),
    },
  })
}
